import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Speaker from "../components/speaker"
// import Newsletter from "../components/newsletter"
// import Sponsor from "../components/sponsor"
import Banner from "../components/banner"

const SpeakerPage = ({ pageContext: { locale } }) => (
  <Layout locale={locale} >
    <SEO title="speaker" />
    <div className="bg-fagioloni bg-fagioloni--offset">
      <div className="bg-fagioloni__left"></div>
      <div className="bg-fagioloni__right"></div>
      <Speaker />
      {/* <Sponsor /> */}
      <Banner />
      {/* <Newsletter /> */}
    </div>
  </Layout>
);

export default SpeakerPage;
